// extracted by mini-css-extract-plugin
export default {"container":"Section4_container__ysN8H","content":"Section4_content__kA07V"};